import React from 'react';

// Simple 💀 V4 alert card: date, MT5 time, pair, BUY/SELL (+ 💀 when conditions are bad) and TRADE.
export const V4AlertCard = ({ notif, idx, onTrade }) => {
  const buy = notif.direction === 'BUY';
  const skull = !!notif.skull;
  return (
    <div data-testid={`notification-card-${idx}`}
      style={{ padding: '1.1rem 1.25rem', borderRadius: 16, boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
        background: skull ? 'linear-gradient(135deg, #fef2f2 0%, #fee2e2 100%)' : 'linear-gradient(135deg, #f0fdfa 0%, #ccfbf1 100%)',
        border: `2px solid ${skull ? '#ef4444' : '#14b8a6'}` }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: '0.75rem', flexWrap: 'wrap', marginBottom: '0.9rem' }}>
        <div style={{ display: 'flex', alignItems: 'baseline', gap: '0.6rem', flexWrap: 'wrap' }}>
          <span data-testid={`notification-date-${idx}`} style={{ fontWeight: 700, color: '#1e293b' }}>{notif.mt5_date}</span>
          <span data-testid={`notification-mt5-time-${idx}`} style={{ color: '#475569', fontWeight: 600 }}>MT5 {notif.mt5_time}</span>
        </div>
        {skull && (
          <span data-testid={`notification-skull-${idx}`} title="Bad market conditions — many of these trades lose. Trade at your own risk."
            style={{ background: '#7f1d1d', color: 'white', borderRadius: 8, padding: '0.3rem 0.65rem', fontWeight: 700, fontSize: '0.8rem' }}>
            💀 Bad conditions
          </span>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '1rem', flexWrap: 'wrap' }}>
        <div data-testid={`notification-pair-${idx}`} style={{ padding: '0.5rem 1rem', background: '#1e293b', color: 'white', borderRadius: 8, fontWeight: 700, fontSize: '1.1rem', letterSpacing: '0.5px' }}>
          {notif.pair}
        </div>
        <div data-testid={`notification-direction-${idx}`} style={{ padding: '0.5rem 1rem', borderRadius: 8, fontWeight: 700, fontSize: '1rem',
          background: buy ? '#dcfce7' : '#fee2e2', color: buy ? '#16a34a' : '#dc2626' }}>
          {buy ? '📈' : '📉'} {notif.direction}
        </div>
      </div>
      {notif.trade_open && (
        <div data-testid={`notification-trade-open-${idx}`} style={{ marginBottom: '0.75rem', padding: '0.6rem 0.8rem', borderRadius: 10, background: '#ecfdf5', border: '1px solid #10b981', color: '#065f46', fontWeight: 700, fontSize: '0.85rem' }}>
          ✅ You placed this trade. This alert stays here until the trade closes.
        </div>
      )}
      <button type="button" data-testid={`trade-btn-${idx}`} onClick={() => onTrade(notif)}
        style={{ width: '100%', padding: '0.85rem 1.5rem', background: '#2563eb', color: 'white', border: 'none', borderRadius: 12, fontWeight: 700, fontSize: '1rem', letterSpacing: '0.04em', cursor: 'pointer', boxShadow: '0 6px 18px -6px rgba(37, 99, 235, 0.6)' }}>
        {notif.trade_open ? '📈 VIEW TRADE' : '📈 TRADE'}
      </button>
      <div style={{ marginTop: '0.75rem', fontSize: '0.78rem', color: '#64748b' }} data-testid={`notification-expiry-${idx}`}>
        {notif.trade_open ? `Alert sent ${notif.age_minutes}m ago` : `Disappears in ${notif.expires_in_min} min unless you place the trade`}
      </div>
    </div>
  );
};
